module.exports = __webpack_public_path__ + "static/media/corner-up-right_new.2c053afc.svg";